import type { GetQuestionnairesApiQuery, QuestionnaireSummaryApi } from "@/Modules/Models/Api/Questionnaire";
import type { QuestionnaireSummary } from "@/Modules/Models/Domain/Questionnaire";
import type { QuestionnaireStore } from "../Store";
import type { QuestionnaireSummaryTransformerType } from "@/Modules/Transformers/Questionaire/QuestionnaireSummary";

import QuestionnaireSummaryTransformer from "@/Modules/Transformers/Questionaire/QuestionnaireSummary";
import { QuestionnaireType } from "@/Modules/Models/Domain/Questionnaire";

import QuestionnairesApiConnector from "@/Services/TherapyApi/Questionnaires";

import { danger } from "@/Utils/Debug";

class FetchCustomerQuestionnairesActionHandler {
  constructor(
    private readonly questionnaireStore: QuestionnaireStore,
    private readonly questionnairesApiConnector = new QuestionnairesApiConnector(),
    private readonly questionnaireSummaryTransformer = QuestionnaireSummaryTransformer
  ) {}

  public async handle(customerUuid: string): Promise<QuestionnaireSummary[]> {
    this.questionnaireStore.isLoading = true;

    const getQuestionnairesApiQuery: GetQuestionnairesApiQuery = {
      page_size: 1000,
    };

    this.questionnairesApiConnector
      .getQuestionnairesByUserId(customerUuid, getQuestionnairesApiQuery)
      .then((questionnaireSummaryApiResponse) => {
        const questionnaires = this.transformQuestionnaireSummaryApiToQuestionnaire(
          questionnaireSummaryApiResponse.body,
          this.questionnaireSummaryTransformer
        );

        this.questionnaireStore.customerQuestionnaires = questionnaires.filter(
          (quiz) => quiz.type !== QuestionnaireType.CUSTOMER_ABOUT_DELETE
        );
      })
      .catch(danger);

    this.questionnaireStore.isLoading = false;

    return this.questionnaireStore.customerQuestionnaires;
  }

  private transformQuestionnaireSummaryApiToQuestionnaire(
    questionnaireSummaryApi: QuestionnaireSummaryApi[],
    transformer: QuestionnaireSummaryTransformerType
  ): QuestionnaireSummary[] {
    const questionnairesSummary: QuestionnaireSummary[] = questionnaireSummaryApi.map(
      (questionnaireSummaryApi) => {
        return transformer.toDomain(questionnaireSummaryApi);
      }
    );

    return questionnairesSummary;
  }
}

export default FetchCustomerQuestionnairesActionHandler;
